// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"94":"webVitals","636":"wix-i18n-config_intl-relativetimeformat","753":"wix-i18n-config_intl-pluralrules"}[chunkId] + ".chunk.min.js";
};